module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-scroller/index.js
// module id = 2473
// module chunks = 0